import Phaser from "phaser"

import { cScene } from "../cScene";
import { ScreenItem } from "../dataTypes";
import { ModuleCollection, Base } from "./modules";


export const parseAssetName = (st: any, type: string) => {
  if (!st) return ''
  let [asset, frame] = String(st).split(':')
  return (type === 'asset') ? asset : frame;
}

export class cSprite extends Phaser.GameObjects.Sprite {

  public dragitem!: any[]
  public modules: ModuleCollection;
  public itemData!: ScreenItem;

  constructor(sc: cScene, data: ScreenItem) {
    super(sc, 0, 0, parseAssetName(data.asset, 'asset') || '', parseAssetName(data.asset, 'frame') || data.frame);
    this.modules = Base.initModules(this, data);
    
  }

  public set frameName(nm: string) {
    if (this.frame && this.scene) {
      this.setFrame(nm)
    }
  }

  public set frameTexture(nm: string) {
    if (this.frame && this.scene) {
      this.setTexture(nm)
    }
  }

  protected appendAnim(name: string, fps: number, frames: string | string[]) {
    var assetName: string = parseAssetName(String(this.itemData.asset), 'asset')
    var animcfg:any = {
      key: name,
      frameRate: Number(fps),
      repeat: 0,      
    }
    if (typeof frames !== 'string'){
      animcfg.frames = []
      frames.forEach((f: string) => {
        var fr: any = {};
        fr.key = assetName;
        fr.frame = f;
        (animcfg.frames as any[]).push(fr)
      })
    }else{
      animcfg.frames = assetName
    }

      console.log('CREATING ANIM', animcfg)
    this.anims.create(animcfg);
  }


  public set animString(nm: string) {
    if (typeof nm !== 'string') return
    var [name, fps, frames] = nm.split(',');
    if (name === '#parse' && this.modules.data._extraData && this.modules.data._extraData.sprite_anim) {
      Object.keys(this.modules.data._extraData.sprite_anim).map((k) => {
        var el = this.modules.data._extraData.sprite_anim[k];
        this.appendAnim(k, el.fps, el.frames.split(';'));
        return null
      })
    } else if(frames){      
      var frameData = (frames.indexOf(';') !== -1) ? frames.split(';') : frames;
      this.appendAnim(name, Number(fps), frameData );
    }
    return;
  }

  
  public set playanim(nm: string) {
    this.play(nm, true);
  }


  set itemDepth(v: number) {
    this.setDepth(v);
    if (this.parentContainer) {
      this.parentContainer.sort('depth')
    }
  }

}